<template>
  <v-app
    :style="{
      backgroundColor: changeColor ? '#F0F0F0' : 'white',
    }"
  >
    <div>
      <v-app-bar
        v-show="!hiddenToolbar"
        fixed
        app
        color="primary"
        dense
        dark
        class="hidden-print-only"
      >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          v-if="!showComputer"
        ></v-app-bar-nav-icon>
        <v-btn v-if="showComputer" icon text @click="$router.back()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title
          ><v-btn
            @focus="selectedComputer = 'home'"
            :style="{
              backgroundColor:
                selectedComputer == 'home' ? '#000080' : 'transparent',
            }"
            text
            @click="changeRouter('/home', 'Home')"
            style="text-transform: none"
          >
            {{ getClickPath() }}
          </v-btn>
        </v-toolbar-title>

        <div class="flex-grow-1"></div>
        <v-btn
          fab
          small
          @focus="selectedComputer = 'History'"
          :style="{
            backgroundColor:
              selectedComputer == 'History' ? '#000080' : 'transparent',
          }"
          text
          @click="changeRouter('/history', 'History')"
          style="text-transform: none"
        >
          <v-icon>mdi-history</v-icon></v-btn
        >
        <v-toolbar-items v-if="showComputer">
          <v-menu
            open-on-hover
            offset-y
            left
            v-if="
              showComputer &&
              (uiAccept.newQuotation ||
                uiAccept.quotationList ||
                uiAccept.toService)
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'service' ? '#000080' : 'transparent',
                }"
              >
                <span
                  class="ml-2 d-none d-sm-flex"
                  style="text-transform: none"
                  >{{ quaOrOrder }}</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in service"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'service'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu
            open-on-hover
            offset-y
            left
            v-if="
              showComputer &&
              (uiAccept.newSale ||
                uiAccept.saleList ||
                uiAccept.returnIn ||
                uiAccept.returnInList)
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'sale' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Sale</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in sale"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'sale'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu
            open-on-hover
            offset-y
            left
            v-if="
              showComputer &&
              (uiAccept.newPurchase ||
                uiAccept.purchaseList ||
                uiAccept.returnOut ||
                uiAccept.returnOutVoucherList ||
                uiAccept.returnOutList)
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'pur' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Purchase</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in purchase"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'pur'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu
            open-on-hover
            offset-y
            left
            v-if="
              showComputer && (uiAccept.cashTransfer || uiAccept.itemTransfer)
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'tran' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Transfer</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in transfer"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'tran'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <!-- <v-menu offset-y left v-if="showComputer && (uiAccept.attendance || uiAccept.salary ) ">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on" 
        :style="{
                  backgroundColor:
                  selectedComputer == 'office' ? '#000080' : 'transparent',
                }">
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Office</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in office"
                  :key="index"
                  @click="changeRouter(item.value,item.clickPath)"
                  @focus="selectedComputer = 'office'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>  -->
          <v-menu
            open-on-hover
            offset-y
            left
            v-if="showComputer && (uiAccept.payment || uiAccept.cashInOut)"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'payment' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Payments</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in payments"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'payment'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>

          <v-menu
            open-on-hover
            offset-y
            left
            v-if="
              showComputer &&
              (uiAccept.billService ||
                uiAccept.grossProfit ||
                uiAccept.paymentReport ||
                uiAccept.stockOnHand ||
                uiAccept.debitCredit ||
                uiAccept.serialReport ||
                uiAccept.salesReport ||
                uiAccept.purchaseReport ||
                uiAccept.profitLoss)
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'report' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Reports</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in reports"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'report'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-menu
            open-on-hover
            offset-y
            left
            v-if="
              showComputer &&
              (uiAccept.product ||
                uiAccept.category ||
                uiAccept.unit ||
                uiAccept.toolBox ||
                uiAccept.township ||
                uiAccept.bank ||
                uiAccept.supplier ||
                uiAccept.userAccount ||
                uiAccept.company)
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
                :style="{
                  backgroundColor:
                    selectedComputer == 'set' ? '#000080' : 'transparent',
                }"
              >
                <span class="ml-2 d-none d-sm-flex" style="text-transform: none"
                  >Settings</span
                >
                <v-icon class="d-none d-sm-flex">mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in settings"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                  @focus="selectedComputer = 'set'"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>

          <v-menu open-on-hover offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <span
                  class="ml-2 d-none d-sm-flex"
                  style="text-transform: none"
                  >{{ loginUser.profileName }}</span
                >
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(item, index) in profileList"
                  :key="index"
                  @click="changeRouter(item.value, item.clickPath)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-list>
          <v-list-item class="px-2">
            <v-list-item-avatar>
              <v-img src="/info/logoprint.png"></v-img>
            </v-list-item-avatar>
            <v-list-item-title class="text-h6">
              {{ loginUser.profileName }}
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-group
            prepend-icon="mdi-sack-percent"
            v-if="
              uiAccept.newQuotation ||
              uiAccept.quotationList ||
              uiAccept.toService
            "
          >
            <template v-slot:activator>
              <v-list-item-title>Service</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in service"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group
            prepend-icon="mdi-cart"
            v-if="
              uiAccept.newSale ||
              uiAccept.saleList ||
              uiAccept.returnIn ||
              uiAccept.returnInList
            "
          >
            <template v-slot:activator>
              <v-list-item-title>Sale</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in sale"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group
            prepend-icon="mdi-cart-plus"
            v-if="
              uiAccept.newPurchase ||
              uiAccept.purchaseList ||
              uiAccept.returnOut ||
              uiAccept.returnOutVoucherList ||
              uiAccept.returnOutList
            "
          >
            <template v-slot:activator>
              <v-list-item-title>Purchase</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in purchase"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group
            prepend-icon="mdi-bank-transfer"
            v-if="uiAccept.cashTransfer || uiAccept.itemTransfer"
          >
            <template v-slot:activator>
              <v-list-item-title>Transfer</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in transfer"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <!-- <v-list-group
        prepend-icon="mdi-cog-outline"
        v-if="(uiAccept.attendance || uiAccept.salary )"
      >
        <template v-slot:activator>
          <v-list-item-title>Office</v-list-item-title>
        </template>
          <v-list-item
            v-for="(item, i) in office"
            :key="i"
            link
            @click="changeRouter(item.value,item.clickPath)"
            @focus="selectIndex = item.value"
            :style="{
                  backgroundColor:
                    selectIndex == item.value ? '#def3ff' : 'transparent',
                }"
          >
          <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
      </v-list-group> -->

          <v-list-group
            prepend-icon="mdi-credit-card-outline"
            v-if="uiAccept.payment || uiAccept.cashInOut"
          >
            <template v-slot:activator>
              <v-list-item-title>Payments</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in payments"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group
            prepend-icon="mdi-poll"
            v-if="
              uiAccept.billService ||
              uiAccept.grossProfit ||
              uiAccept.paymentReport ||
              uiAccept.stockOnHand ||
              uiAccept.debitCredit ||
              uiAccept.serialReport ||
              uiAccept.salesReport ||
              uiAccept.purchaseReport ||
              uiAccept.profitLoss
            "
          >
            <template v-slot:activator>
              <v-list-item-title>Reports</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in reports"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group
            prepend-icon="mdi-cog-outline"
            v-if="
              uiAccept.product ||
              uiAccept.category ||
              uiAccept.unit ||
              uiAccept.toolBox ||
              uiAccept.township ||
              uiAccept.bank ||
              uiAccept.supplier ||
              uiAccept.userAccount ||
              uiAccept.company
            "
          >
            <template v-slot:activator>
              <v-list-item-title>Settings</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in settings"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group prepend-icon="mdi-face">
            <template v-slot:activator>
              <v-list-item-title>My Profile</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item, i) in profileList"
              :key="i"
              link
              @click="changeRouter(item.value, item.clickPath)"
              @focus="selectIndex = item.value"
              :style="{
                backgroundColor:
                  selectIndex == item.value ? '#def3ff' : 'transparent',
              }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list>
        <template v-slot:append>
          <div class="pa-2">
            <v-btn
              class="red--text"
              block
              rounded
              outlined
              @click="changeRouter('/logout', 'Home')"
            >
              <v-icon>mdi-logout</v-icon>Logout
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <div class="mt-12 hidden-print-only"></div>
      <v-container fluid class="mt-0 pa-0">
        <v-progress-linear
          v-if="loading"
          fixed
          :indeterminate="loading"
          color="primary"
        ></v-progress-linear>
        <router-view :hideToolbar="hideToolbar" />
      </v-container>

      <!-- <v-content>
        <v-progress-linear
          v-if="loading"
          fixed
          :indeterminate="loading"
          color="primary"
        ></v-progress-linear>
        <router-view :hideToolbar="hideToolbar" />
      </v-content> -->
      <div>
        <v-dialog v-model="logoutModel" persistent max-width="350">
          <v-card>
            <v-card-title class="title">ထွက်ရန် သေချာပြီလား?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="logoutModel = false"
                >မလုပ်ပါ</v-btn
              >
              <v-btn color="primary" depressed @click="logout">ထွက်မည်</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div>
        <v-dialog v-model="passwordModel" persistent max-width="400">
          <v-form ref="form" v-model="valid">
            <v-card>
              <v-card-title class="headline"
                >စကား၀ှက် ပြောင်းတော့မှာလား?</v-card-title
              >
              <v-card-text class="pb-0">
                <v-text-field
                  :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showOld ? 'text' : 'password'"
                  @click:append="showOld = !showOld"
                  :rules="passwordOldRule"
                  v-model="password.old"
                  label="Old Password"
                  name="oldPassword"
                  placeholder=" "
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showNew ? 'text' : 'password'"
                  @click:append="showNew = !showNew"
                  :rules="passwordNewRule"
                  v-model="password.new"
                  label="New Password"
                  name="newPassword"
                  placeholder=" "
                  outlined
                  dense
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="cancelChangePassword"
                  >မပြောင်းတော့ပါ</v-btn
                >
                <v-btn
                  color="primary"
                  :disabled="!valid"
                  depressed
                  @click="changePassword"
                  >ပြောင်းမည်</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from "../src/config";
import accountUserService from "./service/UserAccountService";
export default {
  mounted: function () {
    this.$router.afterEach((to, from) => {
      const isPublic = to.matched.some((record) => record.meta.public);
      this.eventCount++;
      if (!isPublic) {
        this.$_.delay(() => {
          if (this.eventCount == 1) {
            this.mini = true;
            this.eventCount = 0;
          } else {
            this.eventCount--;
          }
        }, 20000);
      }
    });
  },
  data() {
    return {
      quaOrOrder: "Quotation",
      hiddenToolbar: true,
      logoutModel: false,
      passwordModel: false,
      showOld: false,
      showNew: false,
      password: {},
      valid: true,
      passwordOldRule: [(v) => !!v || "Old Password is required"],
      passwordNewRule: [(v) => !!v || "New Password is required"],
      setting: {},
      limitDialog: false,
      loginUser: "",
      loadingCount: 0,
      loading: false,
      eventCount: 0,
      drawer: false,
      mini: true,
      settings: [
        {
          title: "Product",
          icon: "mdi-chart-ppf",
          value: "/pt",
          clickPath: "Settings > Product",
        },
        {
          title: "Capital",
          icon: "mdi-chip",
          value: "/cpt",
          clickPath: "Settings > Capital",
        },
        {
          title: "Category",
          icon: "mdi-shape",
          value: "/cat",
          clickPath: "Settings > Category",
        },
        {
          title: "Unit",
          icon: "mdi-power-socket-uk",
          value: "/ut",
          clickPath: "Settings > Unit",
        },
        // {
        //   title: "Service Type",
        //   icon: "mdi-toolbox-outline",
        //   value: "/sertype",
        //   clickPath:"Settings > Service Type"
        // },
        {
          title: "Tool Box",
          icon: "mdi-package-variant-closed",
          value: "/ttype",
          clickPath: "Settings > Tool Box",
        },
        // {
        //   title: "Survey Type",
        //   icon: "mdi-comment",
        //   value: "/surveyt",
        // },
        {
          title: "Township",
          icon: "mdi-city",
          value: "/ts",
          clickPath: "Settings > Township",
        },
        {
          title: "Bank",
          icon: "mdi-bank",
          value: "/bank",
          clickPath: "Settings > Bank",
        },
        {
          title: "Supplier",
          icon: "mdi-account",
          value: "/su",
          clickPath: "Settings > Supplier",
        },
        {
          title: "User Account",
          icon: "mdi-account",
          value: "/ua",
          clickPath: "Settings > User Account",
        },
        {
          title: "Company",
          icon: "mdi-domain",
          value: "/comp",
          clickPath: "Settings > Company",
        },
        {
          title: "Ui Accept",
          icon: "mdi-access-point",
          value: "/uiaccept",
          clickPath: "Settings > Ui Accept",
        },
      ],
      service: [
        {
          title: "New Quotation",
          icon: "mdi-sack-percent",
          value: "/quotationsale",
          clickPath: "Service > New Quotation",
        },
        {
          title: "Quotation List",
          icon: "mdi-clipboard-list-outline",
          value: "/quotationlist",
          clickPath: "Service > Quotation List",
        },
        {
          title: "Bill Service",
          icon: "mdi-cash-plus",
          value: "/delivery",
          clickPath: "Service >Bill Service",
        },
      ],
      sale: [
        {
          title: "New Sale",
          icon: "mdi-sale",
          value: "/sale",
          clickPath: "Sale > New Sale",
        },
        {
          title: "Sale List",
          icon: "mdi-clipboard-list",
          value: "/salelist",
          clickPath: "Sale > Sale List",
        },

        {
          title: "Return In",
          icon: "mdi-clipboard-arrow-down",
          value: "/returnin",
          clickPath: "Sale > Return In",
        },
        {
          title: "Return In List",
          icon: "mdi-clipboard-arrow-down",
          value: "/returninlist",
          clickPath: "Sale > Return In List",
        },
        {
          title: "Sale Item List",
          icon: "mdi-contrast-box",
          value: "/pdiffer",
          clickPath: "Sale > Sale Item List",
        },
      ],
      purchase: [
        {
          title: "New Purchase",
          icon: "mdi-storefront",
          value: "/purchase",
          clickPath: "Purchase > New Purchase",
        },
        {
          title: "Purchase List",
          icon: "mdi-clipboard-list-outline",
          value: "/purchaselist",
          clickPath: "Purchase > Purchase List",
        },
        {
          title: "Return Out",
          icon: "mdi-tag-arrow-up",
          value: "/returnout",
          clickPath: "Purchase > Return Out",
        },
        {
          title: "Return Out Voucher List",
          icon: "mdi-clipboard-arrow-down",
          value: "/rovoucherlist",
          clickPath: "Purchase > Return Out Voucher List",
        },
        {
          title: "Return Out List",
          icon: "mdi-clipboard-arrow-down",
          value: "/returnoutlist",
          clickPath: "Purchase > Return Out List",
        },
      ],
      office: [
        {
          title: "Attendance",
          icon: "mdi-spellcheck",
          value: "/attendance",
          clickPath: "Office > Attendance",
        },

        // {
        //   title: "Finance",
        //   icon: "mdi-finance",
        //   value: "/finance",
        // },
        // {
        //   title: "Survey",
        //   icon: "mdi-comment",
        //   value: "/survey",
        // },
        {
          title: "Salary",
          icon: "mdi-finance",
          value: "/sala",
          clickPath: "Office > Salary",
        },
      ],
      reports: [
        {
          title: "Bill Service(G Profit)",
          icon: "mdi-cash-100",
          value: "/grossbill",
          clickPath: "Reports > Bill Service(G Profit)",
        },
        {
          title: "Gross Profit",
          icon: "mdi-cash-100",
          value: "/gross",
          clickPath: "Reports > Gross Profit",
        },
        {
          title: "Payment",
          icon: "mdi-cash-100",
          value: "/reportbt",
          clickPath: "Reports > Payment",
        },
        {
          title: "Stock On Hand",
          icon: "mdi-scale-balance",
          value: "/soh",
          clickPath: "Reports > Stock On Hand",
        },
        {
          title: "DebitCredit",
          icon: "mdi-cash-100",
          value: "/debitcredit",
          clickPath: "Reports > DebitCredit",
        },
        {
          title: "Serial Report",
          icon: "mdi-scale-balance",
          value: "/reportseries",
          clickPath: "Reports > Serial Report",
        },
        {
          title: "Sales Report",
          icon: "mdi-chart-box-outline",
          value: "/reportsale",
          clickPath: "Reports > Sales Report",
        },
        {
          title: "Purchase Report",
          icon: "mdi-chart-box-outline",
          value: "/reportpur",
          clickPath: "Reports > Purchase Report",
        },
        //  {
        //     title: "Income Report",
        //   icon: "mdi-credit-card-marker",
        //   value: "/ri",
        //   clickPath:"Reports > Income Report"
        // },
        //  {
        //       title: "Expense Report",
        //     icon: "mdi-credit-card-settings-outline",
        //     value: "/re",
        //     clickPath:"Reports > Expense Report"
        //   },
        {
          title: "Profit & Loss",
          icon: "mdi-credit-card-settings-outline",
          value: "/profitloss",
          clickPath: "Reports > Profit & Loss",
        },
      ],
      payments: [
        {
          title: "Payment",
          icon: "mdi-cash-plus",
          value: "/py",
          clickPath: "Payments > Payment",
        },
        // {
        //   title: "Income",
        //   icon: "mdi-credit-card-marker",
        //   value: "/ic",
        // },
        {
          title: "Cash In/Out",
          icon: "mdi-credit-card-settings-outline",
          value: "/ep",
          clickPath: "Payments > Cash In/Out",
        },
      ],
      transfer: [
        {
          title: "Cash Transfer",
          icon: "mdi-cash",
          value: "/cashtransfer",
          clickPath: "Transfer > Cash Transfer",
        },
        {
          title: "Item Transfer",
          icon: "mdi-chart-ppf",
          value: "/itransfer",
          clickPath: "Transfer > Item Transfer",
        },
      ],
      profileList: [
        {
          title: "Change Password",
          icon: "mdi-lock",
          value: "/change_password",
        },
        {
          title: "Logout",
          icon: "mdi-logout",
          value: "/logout",
        },
      ],
      selectIndex: "home",
      selectedComputer: "home",
      clickPath: "Home",
      uiAccept: {},
      changeColor: true,
    };
  },
  props: {},
  mounted: function () {
    this.hiddenToolbar = false;
    this.loginMounted();
    if (this.loginUser.domain == "tms") {
      this.quaOrOrder = "Quotation";
    } else {
      this.quaOrOrder = "Order";
    }
    axios.interceptors.request.use((config) => {
      this.loadingCount++;
      if (!this.loading) {
        this.loading = true;
      }
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return response;
      },
      (error) => {
        if (error.isAxiosError && error.message == "Network Error") {
          this.$swal("အင်တာနက် လိုင်းမကောင်းပါ", error.message, "error");
          this.loadingCount = 1;
          this.loading = false;
        }
        if (error.response.data != null && error.response.data.status == 401) {
          this.$swal(
            "Authentication Error",
            "ထွက်မည် ခလုတ်နှိပ်ပေးပါ",
            "error"
          );
          this.changeRouter("/logout", "Home");
          this.logout();
        }
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return Promise.reject(error);
      }
    );
  },
  computed: {
    showComputer() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
    isLogin: function () {
      let token = this.$store.state.userAccount.password;
      if (token == "") {
        return false;
      } else {
        axios.defaults.headers.common["Authorization"] = `gps${token}`;
        this.uiAcceptMethod();
        return true;
      }
    },
  },
  methods: {
    getClickPath: function () {
      var title = "";
      title = this.getCookies("clickPath");
      if (title != "") {
        return title;
      } else {
        return this.clickPath;
      }
    },
    clickDrawer: function (item) {
      this.drawer = false;
      this.changeRouter(item.value, item.clickPath);
    },
    changePassword: function () {
      accountUserService
        .changePassword(this.password.old, this.password.new)
        .then((response) => {
          if (response > 0) {
            this.$swal("Successful", "Change Password", "success");
            this.logout();
          } else {
            this.$swal("unSuccessful", "Change Password", "error");
          }
          this.password = {
            old: "",
            new: "",
          };
        });
      this.passwordModel = false;
    },
    cancelChangePassword: function () {
      this.passwordModel = false;
      this.password = {};
    },
    hideToolbar: function (hide, print) {
      this.hiddenToolbar = hide;
      this.changeColor = print;
      this.loginMounted();
    },
    changeRouter: function (path, clickPath) {
      this.clickPath = clickPath;
      document.cookie = "clickPath=" + clickPath;
      if (path == "/sale" || path == "/purchase") {
        window.location.href = path;
      } else if (path == "/logout") {
        this.logoutModel = true;
      } else if (path == "/change_password") {
        this.passwordModel = true;
      } else {
        this.$router
          .push({
            path: path,
          })
          .catch(() => {});
      }
      this.changeColor = true;
    },
    logout: function () {
      this.$store.commit("updateUserAccount", {
        userName: "",
        password: "",
        role: "",
      });
      this.changeRouter("/login", "Home");
      location.reload();
      this.logoutModel = false;
      this.hiddenToolbar = true;
    },
    loginMounted() {
      if (this.isLogin) {
        this.loginUser = this.$store.state.userAccount;
        this.hiddenToolbar = false;
      } else {
        this.hiddenToolbar = true;
        this.$router.push("/login").catch(() => {});
      }
    },
    // loginMounted() {
    //   if (this.isLogin) {
    //     this.loginUser = this.$store.state.userAccount;
    //     if(this.loginUser.role=="PATIENT"){
    //           this.$router.push("/p/patient").catch(() => {});
    //           location.reload();
    //         }
    //     this.hiddenToolbar = false;
    //   } else {
    //     this.hiddenToolbar = true;
    //     this.$router.push("/p/onesignal").catch(() => {});
    //     location.reload();
    //   }
    // },
    uiAcceptMethod: function () {
      accountUserService
        .getUiByUserId()
        .then((response) => {
          this.uiAccept = Object.assign({}, response);
          this.$store.commit("updateUiAccept", response);
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    },
    getCookies: function (cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
  watch: {
    uiAccept: function () {
      this.service.splice(0);
      if (this.uiAccept.newQuotation) {
        //   if(this.loginUser.domain=="tm"){
        //     this.service.push({
        //       title: "New Quotation",
        //     icon: "mdi-sack-percent",
        //     value: "/quotationsale",
        //     clickPath:"Service > New Quotation"
        //   });
        //   }else{
        this.service.push({
          title: "New Order",
          icon: "mdi-sack-percent",
          value: "/quotationsale",
          clickPath: "Service > New Order",
        });
        // }
      }
      if (this.uiAccept.quotationList) {
        // if(this.loginUser.domain=="tm"){
        this.service.push({
          title: "Order List",
          icon: "mdi-clipboard-list-outline",
          value: "/quotationlist",
          clickPath: "Service > Order List",
        });
        // }else{
        //   this.service.push({
        //     title: "Order List",
        //   icon: "mdi-clipboard-list-outline",
        //   value: "/quotationlist",
        //   clickPath:"Service > Quotation List"
        // });
        // }
      }
      // if(this.uiAccept.toService){
      //     this.service.push({
      //       title: "Bill Service",
      //     icon: "mdi-cash-plus",
      //     value: "/delivery",
      //     clickPath:"Service > Bill Service"
      //   });
      // }

      this.sale.splice(0);
      if (this.uiAccept.newSale) {
        this.sale.push({
          title: "New Sale",
          icon: "mdi-sale",
          value: "/sale",
          clickPath: "Sale > New Sale",
        });
      }
      if (this.uiAccept.saleList) {
        this.sale.push({
          title: "Sale List",
          icon: "mdi-clipboard-list",
          value: "/salelist",
          clickPath: "Sale > Sale List",
        });
      }
      if (this.uiAccept.priceDifference) {
        this.sale.push({
          title: "Sale Item List",
          icon: "mdi-contrast-box",
          value: "/pdiffer",
          clickPath: "Sale > Sale Item List",
        });
      }
      //   if(this.uiAccept.returnIn){
      //   this.sale.push({
      //     title: "Return In",
      //     icon: "mdi-clipboard-arrow-down",
      //     value: "/returnin",
      //     clickPath:"Sale > Return In"
      //   });
      // }
      //   if(this.uiAccept.returnInList){
      //   this.sale.push({
      //     title: "Return In List",
      //     icon: "mdi-clipboard-arrow-down",
      //     value: "/returninlist",
      //     clickPath:"Sale > Return In List"
      //   });
      // }

      this.purchase.splice(0);
      if (this.uiAccept.newPurchase) {
        this.purchase.push({
          title: "New Purchase",
          icon: "mdi-storefront",
          value: "/purchase",
          clickPath: "Purchase > New Purchase",
        });
      }
      if (this.uiAccept.purchaseList) {
        this.purchase.push({
          title: "Purchase List",
          icon: "mdi-clipboard-list-outline",
          value: "/purchaselist",
          clickPath: "Purchase > Purchase List",
        });
        this.purchase.push({
          title: "Purchase Item List",
          icon: "mdi-contrast-box",
          value: "/puritemlist",
          clickPath: "Purchase > Purchase Item List",
        });
      }
      //   if(this.uiAccept.returnOut){
      //   this.purchase.push({
      //     title: "Return Out",
      //     icon: "mdi-tag-arrow-up",
      //     value: "/returnout",
      //     clickPath:"Purchase > Return Out"
      //   });
      // }
      //   if(this.uiAccept.returnOutVoucherList){
      //   this.purchase.push({
      //     title: "Return Out List",
      //     icon: "mdi-clipboard-arrow-down",
      //     value: "/rovoucherlist",
      //     clickPath:"Purchase > Return Out List"
      //   });
      // }
      //   if(this.uiAccept.returnOutList){
      //   this.purchase.push({
      //     title: "Return Out List",
      //     icon: "mdi-clipboard-arrow-down",
      //     value: "/returnoutlist",
      //     clickPath:"Purchase > Return Out List"
      //   });
      // }

      this.transfer.splice(0);
      if (this.uiAccept.cashTransfer) {
        this.transfer.push({
          title: "Cash Transfer",
          icon: "mdi-cash",
          value: "/cashtransfer",
          clickPath: "Transfer > Cash Transfer",
        });
      }
      if (this.uiAccept.storeTransfer) {
        this.transfer.push({
          title: "Store Transfer",
          icon: "mdi-chart-ppf",
          value: "/itransfer",
          clickPath: "Transfer > Store Transfer",
        });
      }
      if (this.uiAccept.itemTransfer) {
        this.transfer.push({
          title: "Item Transfer",
          icon: "mdi-hammer-screwdriver",
          value: "/trans",
          clickPath: "Transfer > Item Transfer",
        });
      }
      if (this.uiAccept.rawItem) {
        this.transfer.push({
          title: "Raw Item",
          icon: "mdi-palette-swatch",
          value: "/rwi",
          clickPath: "Transfer > Raw Item",
        });
      }
      if (this.uiAccept.capital) {
        this.transfer.push({
          title: "Capital",
          icon: "mdi-home-floor-1",
          value: "/cpt",
          clickPath: "Transfer > Capital",
        });
      }

      this.office.splice(0);
      // if(this.uiAccept.attendance){
      //   this.office.push({
      //     title: "Attendance",
      //     icon: "mdi-spellcheck",
      //     value: "/attendance",
      //     clickPath:"Office > Attendance"
      //   });
      // }
      // if(this.uiAccept.salary){
      //   this.office.push({
      //     title: "Salary",
      //     icon: "mdi-finance",
      //     value: "/sala",
      //     clickPath:"Office > Salary"
      //   });
      // }

      this.payments.splice(0);
      if (this.uiAccept.payment) {
        this.payments.push({
          title: "Payment",
          icon: "mdi-cash-plus",
          value: "/py",
          clickPath: "Payments > Payment",
        });
      }
      if (this.uiAccept.cashInOut) {
        this.payments.push({
          title: "Cash In/Out",
          icon: "mdi-credit-card-settings-outline",
          value: "/ep",
          clickPath: "Payments > Cash In/Out",
        });
      }

      this.reports.splice(0);
      // if(this.uiAccept.billService){
      //   this.reports.push({
      //     title: "Daily Cash",
      //     icon: "mdi-cash-100",
      //     value: "/dailyinout",
      //     clickPath:"Reports > Daily Cash"
      //   });
      //   this.reports.push({
      //     title: "Bill Service(G Profit)",
      //     icon: "mdi-cash-100",
      //     value: "/grossbill",
      //     clickPath:"Reports > Bill Service(G Profit)"
      //   });

      // }
      if (this.uiAccept.grossProfit) {
        this.reports.push({
          title: "Gross Profit",
          icon: "mdi-cash-100",
          value: "/gross",
          clickPath: "Reports > Gross Profit",
        });
      }
      if (this.uiAccept.rawGoodsReport) {
        this.reports.push({
          title: "Store Report",
          icon: "mdi-chart-ppf",
          value: "/reportrawgoods",
          clickPath: "Reports > Store Report",
        });
      }
      if (this.uiAccept.paymentReport) {
        this.reports.push({
          title: "CashBook",
          icon: "mdi-cash-lock",
          value: "/reportbt",
          clickPath: "Reports > CashBook",
        });
        this.reports.push({
          title: "Payment",
          icon: "mdi-cash-multiple",
          value: "/repayment",
          clickPath: "Reports > Payment",
        });
      }
      if (this.uiAccept.cashreport) {
        this.reports.push({
          title: "Cash In/Out",
          icon: "mdi-credit-card-settings-outline",
          value: "/crp",
          clickPath: "Reports > Cash In/Out",
        });
      }
      if (this.uiAccept.stockOnHand) {
        this.reports.push({
          title: "Stock On Hand Daily",
          icon: "mdi-scale-balance",
          value: "/daily/soh",
          clickPath: "Reports > Stock On Hand Daily",
        });
        this.reports.push({
          title: "Stock On Hand",
          icon: "mdi-scale-balance",
          value: "/soh",
          clickPath: "Reports > Stock On Hand",
        });
      }
      if (this.uiAccept.debitCredit) {
        this.reports.push({
          title: "DebitCredit",
          icon: "mdi-account-cash-outline",
          value: "/debitcredit",
          clickPath: "Reports > DebitCredit",
        });
      }
      //   if(this.uiAccept.serialReport){
      //   this.reports.push({
      //     title: "Serial Report",
      //     icon: "mdi-scale-balance",
      //     value: "/reportseries",
      //     clickPath:"Reports > Serial Report"
      //   });
      // }
      if (this.uiAccept.salesReport) {
        this.reports.push({
          title: "Sales Report",
          icon: "mdi-clipboard-list",
          value: "/reportsale",
          clickPath: "Reports > Sales Report",
        });
      }
      if (this.uiAccept.purchaseReport) {
        this.reports.push({
          title: "Purchase Report",
          icon: "mdi-clipboard-list-outline",
          value: "/reportpur",
          clickPath: "Reports > Purchase Report",
        });
      }

      if (this.uiAccept.capitalReport) {
        this.reports.push({
          title: "Capital Report",
          icon: "mdi-credit-card-settings-outline",
          value: "/reportcapital",
          clickPath: "Reports > Capital Report",
        });
      }
      if (this.uiAccept.profitLoss) {
        this.reports.push({
          title: "Manufacturing Month",
          icon: "mdi-calendar-month-outline",
          value: "/rpmanu",
          clickPath: "Reports > Manufacturing Month",
        });
        this.reports.push({
          title: "Profit & Loss Month",
          icon: "mdi-calendar-month-outline",
          value: "/plmonth",
          clickPath: "Reports > Profit & Loss Month",
        });
        this.reports.push({
          title: "Profit & Loss",
          icon: "mdi-finance",
          value: "/profitloss",
          clickPath: "Reports > Profit & Loss",
        });
      }

      this.settings.splice(0);
      if (this.uiAccept.product) {
        this.settings.push({
          title: "Product",
          icon: "mdi-chart-ppf",
          value: "/pt",
          clickPath: "Settings > Product",
        });
      }
      if (this.uiAccept.category) {
        this.settings.push({
          title: "Category",
          icon: "mdi-shape",
          value: "/cat",
          clickPath: "Settings > Category",
        });
      }
      if (this.uiAccept.unit) {
        this.settings.push({
          title: "Unit",
          icon: "mdi-power-socket-uk",
          value: "/ut",
          clickPath: "Settings > Unit",
        });
      }
      //   if(this.uiAccept.toolBox){
      //   this.settings.push({
      //     title: "Tool Box",
      //     icon: "mdi-package-variant-closed",
      //     value: "/ttype",
      //     clickPath:"Settings > Tool Box"
      //   });
      // }
      if (this.uiAccept.township) {
        this.settings.push({
          title: "Township",
          icon: "mdi-city",
          value: "/ts",
          clickPath: "Settings > Township",
        });
      }
      if (this.uiAccept.bank) {
        this.settings.push({
          title: "Bank",
          icon: "mdi-bank",
          value: "/bank",
          clickPath: "Settings > Bank",
        });
      }
      if (this.uiAccept.supplier) {
        this.settings.push({
          title: "Supplier",
          icon: "mdi-account",
          value: "/su",
          clickPath: "Settings > Supplier",
        });
      }
      if (this.uiAccept.userAccount) {
        this.settings.push({
          title: "User Account",
          icon: "mdi-account",
          value: "/ua",
          clickPath: "Settings > User Account",
        });
      }
      if (this.uiAccept.branch) {
        this.settings.push({
          title: "Branch",
          icon: "mdi-office-building",
          value: "/branch",
          clickPath: "Settings > Branch",
        });
      }
      if (this.uiAccept.company) {
        this.settings.push({
          title: "Company",
          icon: "mdi-domain",
          value: "/comp",
          clickPath: "Settings > Company",
        });
      }
      if (this.$store.state.userAccount.role == "ADMIN") {
        this.settings.push({
          title: "Ui Accept",
          icon: "mdi-access-point",
          value: "/uiaccept",
          clickPath: "Settings > Ui Accept",
        });
      }
    },
  },
  components: {},
  name: "App",
};
</script>
<style scope>
html::-webkit-scrollbar {
  width: 0px;
}

html::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);
  border-radius: 3px;
}

html::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #4caf50;
  padding: 3px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

div::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);

  border-radius: 3px;
}

div::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #4caf50;
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.5);
}
</style>
